import { ReactElement } from 'react';
import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { AdminService, formatDateTimeTimezone, useApiGetter } from '@localstack/services';
import { User } from '@localstack/types';
import { TEST_IDS } from '@localstack/constants';

interface LegalAcceptanceLogProps {
  user: User;
}

export const LegalAcceptanceLog = ({ user }: LegalAcceptanceLogProps): ReactElement => {
  const { data: acceptances } = useApiGetter(AdminService, 'listUserLegalAcceptances', [user.id]);

  return (
    <Card>
      <CardHeader title="Legal Acceptance" />
      <CardContent>
        {!acceptances?.length ? (
          <Typography variant="body1">No legal acceptances recorded.</Typography>
        ) : (
          <Box display="flex" flexDirection="column" gap={2}>
            {acceptances.map((acceptance) => (
              <Box key={acceptance.id} borderBottom="1px solid" borderColor="divider" pb={2}>
                <Typography variant="body1">
                  <b>Document Type:</b> {acceptance.document_type}
                  <br />
                  <b>Source:</b> <span data-testid={TEST_IDS.ADMIN_LEGAL_ACCEPTANCE_SOURCE}>{acceptance.source}</span>
                  <br />
                  <b>Organisation:</b> {acceptance.org_name} ({acceptance.org_id})
                  <br />
                  <b>User Email:</b> {acceptance.user_email}
                  {acceptance.context && (
                    <>
                      <br />
                      <b>Context:</b> {acceptance.context}
                    </>
                  )}
                  {acceptance.timestamp && (
                    <>
                      <br />
                      <b>Time:</b> {formatDateTimeTimezone(acceptance.timestamp)}
                    </>
                  )}
                  {acceptance.client_ip && (
                    <>
                      <br />
                      <b>Client IP:</b>{' '}
                      <span data-testid={TEST_IDS.ADMIN_LEGAL_ACCEPTANCE_IP_ADDRESS}>{acceptance.client_ip}</span>
                    </>
                  )}
                  <br />
                  <b>User Agent:</b> <span style={{ fontFamily: 'monospace' }}>{acceptance.user_agent}</span>
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
